import React, { useState, useEffect } from "react";
import { Form, Button } from "antd";
import "./styles.scss";
import { Editor } from "@tinymce/tinymce-react";
import firebase from "firebase";
import ImageUploader from "./imageUploader";

const FormOriginal = (props) => {
  const { getFieldDecorator } = props.form;
  const [value, setValue] = useState("");
  const [content, setContent] = useState("");

  return (
    <div className="contactFormBlogWrapper">
      <div
        style={{
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <form
          className="contactFormBlog"
          onSubmit={(e) => props.handleSubmit(e, props.form)}
        >
          <div
            style={{
              display: "flex",
              flex: "1",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <Form.Item style={{ width: "100%" }} label="Kargo Firmasi">
              {getFieldDecorator("cargoCompany", {
                initialValue:
                  props.defaultValues && props.defaultValues.cargoCompany,
                rules: [
                  {
                    required: true,
                    message: "Please input your product name!",
                  },
                ],
              })(
                <input
                  placeholder="Kargo Firmasi"
                  className="contactFormBlogInput"
                />
              )}
            </Form.Item>
            <Form.Item style={{ width: "100%" }} label="Kargo Takip Numarasi">
              {getFieldDecorator("trackNumber", {
                initialValue:
                  props.defaultValues && props.defaultValues.trackNumber,
                rules: [
                  {
                    required: true,
                    message: "Please input your product name!",
                  },
                ],
              })(
                <input
                  placeholder="Kargo Takip Numarasi"
                  className="contactFormBlogInput"
                />
              )}
            </Form.Item>
          </div>

          <Form.Item style={{ width: "100%" }}>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              {props.type}
            </Button>
          </Form.Item>
        </form>
      </div>
    </div>
  );
};
const WrappedNormalLoginForm = Form.create({ name: "productCreate" })(
  FormOriginal
);

export default WrappedNormalLoginForm;
